import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import {
  clearLogoutIntentIfStartingSignInOrImpersonation,
  seedSuperadminHandoffOidcSessionFromUrl,
  stripOAuthParamsIfPendingLogoutReturn,
} from '@/bootstrapAuthUrl';
import { registerStaleAssetHandlers } from '@/bootstrapAppVersion';
import App from './App.tsx';

const bootstrap = async (): Promise<void> => {
  clearLogoutIntentIfStartingSignInOrImpersonation();
  stripOAuthParamsIfPendingLogoutReturn();
  await seedSuperadminHandoffOidcSessionFromUrl();
  registerStaleAssetHandlers();

  createRoot(document.getElementById('root') as HTMLElement).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
};

void bootstrap();
